export default "__VITE_ASSET__wNErx_lR__"